import { getAssetUrl } from './config';

const assetsToPreload = ['common/infoBlue.svg'];

export const preloadAssets = () => {
  assetsToPreload.forEach(path => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = getAssetUrl(path);
    link.as = 'image';
    document.head.appendChild(link);
  });
};
